import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { load3DSceneTextures } from '@3jss/utils/LOD_helper';
import { DracoManager } from '@3jss/DracoManager';

const glbLoader = new GLTFLoader();
const dracoManager = new DracoManager();
const imageLoader = new THREE.ImageLoader();
const fileLoader = new THREE.FileLoader();

export const LOD_TO_GRID_SEGMENTS_MAP = Object.freeze({
	0: 1,
	1: 2,
	2: 4,
	3: 8,
});

export const LOD_TO_RESOLUTION = Object.freeze({
	0: '512',
	1: '1k',
	2: '2k',
	3: '4k',
});

export const buildLODUrls = (
	baseUrl,
	face,
	LOD,
	imageIntegrity = null,
	useWebp = false,
) => {
	if (!baseUrl) return null;

	const loadOrder = [];
	const iterations = LOD_TO_GRID_SEGMENTS_MAP[LOD];
	const resolution = LOD_TO_RESOLUTION[LOD];

	for (let i = iterations - 1; i >= 0; i -= 1) {
		for (let j = 0; j < iterations; j += 1) {
			let imageName = `${baseUrl}${resolution}_${face}_${i}_${j}.${
				useWebp ? 'webp' : 'jpg'
			}`;
			if (imageIntegrity) {
				imageName = `${imageName}?v=${imageIntegrity}`;
			}
			loadOrder.push(imageName);
		}
	}
	return loadOrder;
};

export const preloadObject = (url) => {
	glbLoader.setDRACOLoader(dracoManager.getInstance());
	return new Promise((resolve, reject) => {
		glbLoader.load(
			url,
			(gltf) => {
				resolve(gltf);
				dracoManager.dispose();
			},
			(xhr) => {},
		);
	});
};

export const preloadSceneTexture = (url) => {
	return new Promise((resolve, reject) => {
		load3DSceneTextures(url).then(() => {
			resolve();
		});
	});
};

export const preLoadConnectedScenes = (linkedScenes, abortControl) => {
	const levelsToPreLoad = [1];
	const facesToPreLoad = ['front', 'left', 'right', 'top', 'bottom', 'back'];
	linkedScenes.forEach((item) => {
		if ('scene_model' in item) {
			glbLoader.load(`${item.scene_model}`, () => {});
		}

		if ('scene_background' in item) {
			load3DSceneTextures(item.scene_background);
		}
		if ('environment_map' in item) {
			load3DSceneTextures(item.environment_map);
		}

		if ('cube_map_dir' in item) {
			levelsToPreLoad.forEach((level) => {
				facesToPreLoad.forEach((face) => {
					buildLODUrls(
						item?.cube_map_dir,
						face,
						level,
						item?.imageIntegrity,
						item?.useWebp,
					).map((item) =>
						imageLoader.load(item, null, null, abortControl.signal),
					);
				});
			});
		}
	});
};


export const rotateCameraTowardsPoint = (
	point,
	camera,
	controls,
) => {
	return controls.lookInDirectionOf(point.x, point.y, point.z, true);
};
